<template>
  <v-app class="page page-base">
     <v-app-bar
      class="header-list pl-6 pr-8 py-3"
      app
      fixed
      elevation="0"
      color="lightPrimary"
      height="80"
    >
      <div class="d-flex flex-grow-1 justify-space-between">
       <div class="d-flex align-center">
          <v-breadcrumbs
              class="menu-breadcrumbs pa-0 ml-4"
              :items="breadcrumbs"
              divider=">"
                  >
            </v-breadcrumbs>
       </div>
       <div class="d-flex align-center">
        <NotificationMenu></NotificationMenu>
       </div>
    </div>
    </v-app-bar>
    <v-main>
      <v-container fluid class="fill-height pr-0 pb-0 pa-0">
        <v-card
          width="100%"
          elevation="0"
          class="full-height fill-width fill-height card-content"
          :loading="status === 'loading'"
        >
          <v-card-text class="pb-0">
            <div class="d-flex justify-space-between align-center mb-10">
              <div>
                <h3 class="title-section">{{ title }}</h3>
              </div>
              <div class="d-flex">
                <v-btn
                  rounded
                  class="custom-btn-round-success btn-round-md"
                  @click="submit"
                  :loading="status === 'loading'"
                >
                  <span class="fonts-s14 fonts-600 fonts-color-whiteLight fonts-family-poppins">{{ labelSubmit }}</span>
                </v-btn>
              </div>
            </div>
            <div  style="max-height: calc(100vh - 220px); overflow-y: auto">
              <v-container class="pos-relative pb-0 pt-4 ">
                <ValidationObserver ref="validator" v-slot="{}">
                  <v-form>
                    <v-row no-gutters justify="center">
                      <v-col cols="6" >
                        <v-row no-gutters>
                          <v-col class="py-0 px-2">
                            <ValidationProvider ref="name" rules="required"
                                                v-slot="{ errors }">
                              <div class="label-base pb-1">Nombre</div>
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.name"
                                label="Nombre"
                                autocomplete="off"
                                readonly
                                solo
                                hide-details="auto"
                                class="input-base"
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                          <v-col class="py-0 px-2">
                            <ValidationProvider ref="email" rules="required|email"
                                                v-slot="{ errors }">
                              <div class="label-base pb-1">E-mail</div>
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.email"
                                label="E-mail"
                                prepend-inner-icon="fas fa-envelope"
                                autocomplete="off"
                                readonly
                                solo
                                hide-details="auto"
                                class="input-base"
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col class="py-0 px-2">
                            <ValidationProvider ref="password" rules="min:4"
                                                v-slot="{ errors }">
                              <div class="label-base pb-1">Password</div>
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.password"
                                label="Password"
                                :type="show1 ? 'text' : 'password'"
                                :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                @click:append="show1 = !show1"
                                autocomplete="off"
                                readonly
                                solo
                                hide-details="auto"
                                class="input-base"
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <!-- <v-card-text class="text-center">
                        <v-btn
                          color="warning"
                          elevation="0"
                          class="mr-4"
                          v-on:click="$router.push('/admin/users')"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="primary"
                          class="mr-4"
                          @click="submit"
                          :loading="status == 'loading'"
                        >
                          Guardar
                        </v-btn>
                        </v-card-text> -->
                      </v-col>
                    </v-row>

                  </v-form>
                </ValidationObserver>
              </v-container>
            </div>
          </v-card-text>
          <!-- <v-card-actions class="justify-center pa-0">
            
          </v-card-actions> -->
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import NotificationMenu from "@/components/Notification/NotificationMenu.vue";
  export default {
    created() {
      const self = this;
      this.$store.dispatch('Authenticate/me').then(function (profile) {
        self.user.id = profile.id;
        self.user.name = profile.name;
       /*  self.user.apodo = profile.apodo; */
        self.user.email = profile.email;
      });
    },
    computed: {
      ...mapState({
        status: state => state.Users.status,
        roles: state => state.Users.roles,
      })
    },
    data() {
      return {
        show1: "",
        title: "Editar perfil",
        labelSubmit: "Guardar",
        breadcrumbs: [
          
          {
            text: "Perfil",
            disabled: true,
            href: "/admin/profile/edit",
          },
        ],
        user: {
          id: '',
          name: '',
          /* apodo: '', */
          email: '',
          password: '',
        },
      }
    },
    methods: {
      async submit() {
        const self = this;

        let valid = await self.$refs.validator.validate();

        if (valid) {

          self.$store.dispatch('Users/update', self.user).then(function () {

            self.$store.dispatch('Authenticate/me');
            self.$router.push('/admin/users');

          }).catch(function (response) {
            for (let i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
        }
      }
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      NotificationMenu
    },
  }
  ;
</script>
